module.exports = __webpack_public_path__ + "static/media/mobile_theme_2x.dfc0ad02.png";